import { render } from "./IntroductionCollect.vue?vue&type=template&id=6b32d4e6"
import script from "./IntroductionCollect.vue?vue&type=script&lang=js"
export * from "./IntroductionCollect.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__